import { render, staticRenderFns } from "./UsersCrud.vue?vue&type=template&id=4bb46d32&scoped=true"
import script from "./UsersCrud.vue?vue&type=script&lang=js"
export * from "./UsersCrud.vue?vue&type=script&lang=js"
import style0 from "./UsersCrud.vue?vue&type=style&index=0&id=4bb46d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb46d32",
  null
  
)

export default component.exports